module.exports = __webpack_public_path__ + "assets/img/Chill-out Pavilion.1f75f348.jpg";